import axios, { AxiosRequestHeaders } from "axios";
import { apiEndpoint } from "helpers/constants/config.constants";

export const httpPost = async (url: string, body: Record<string, unknown>, headers: Record<string, unknown> = {}) => {
  try {
    const response = await axios.post(`${apiEndpoint}${url}`, body, {
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
        ...headers
      },
    });
    return response;
  } catch (error) {
    console.error('Error:', error);
  }
}

export const httpGet = async (url: string, body: Record<string, unknown> = {}) => {
  try {
    const headers: Partial<AxiosRequestHeaders> = {
      'Content-type': 'application/json; charset=UTF-8',
      'Accept': 'application/json',
    };

    if (localStorage.getItem('accessToken')) {
      headers.Authorization = 'Bearer ' + localStorage.getItem('accessToken') as string;
    }
    const response = await axios.get(`${apiEndpoint}${url}`, {
      params: body,
      headers: headers as AxiosRequestHeaders,
    });
    return response;
  } catch (error) {
    console.error('Error:', error);
  }
}

export const httpPatch = async (url: string, data: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    axios.patch(`${apiEndpoint}${url}`, data, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
      }
    }).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
}

export const httpPut = async (url: string, data: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    axios.put(`${apiEndpoint}${url}`, data, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
      }
    }).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
}

export const httpDelete = (url: string) => {
  return new Promise((resolve, reject) => {
    axios.delete(`${apiEndpoint}${url}`, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
      }
    }).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
}
